import Cookies from 'modules/Cookies';
import { isMl3App, isiOS } from 'modules/DeviceOptions';

const iOSLocalServer = 'http://localhost:8080/?';

// ASグローバル変数が未定義の場合（スタンドアロンテストページなど）のフォールバック
if (typeof window.AS === 'undefined') {
  window.AS = {
    domains: {
      image: '',
      api: '',
      route: ''
    }
  };
}

window.ImageDomainURLRead = `${AS.domains.image}/`;

if (isMl3App && isiOS && Cookies.get('app_version')) {
  window.ImageDomainURLRead = `${iOSLocalServer}${window.ImageDomainURLRead}`;
  AS.domains.image = `${iOSLocalServer}${AS.domains.image}`;
}

// ================================================
// ================================================
// ================================================

const imageOnLoad = async elm => {
  const img = $(elm);
  const image_id = img.data('imageid');
  const imgWidth = elm.naturalWidth;
  const imgHeight = elm.naturalHeight;
  const parent = img.parent();
  let size = parent.width();
  size = size < parent.height() ? parent.height() : size;

  parent.css('background', `url("${elm.src}") no-repeat`);

  if (image_id && imgWidth < parent.width() && imgHeight < parent.height()) {
    try {
      const newImg = await imageCheckBetterQuality(elm.src, image_id, size);
      if (newImg.naturalWidth > imgWidth || newImg.naturalHeight > imgHeight) {
        parent.css('background', `url("${newImg.src}") no-repeat`);
      }
    } catch (e) {
      console.log(e);
    }
  }
};

const imageOnError = async elm => {
  // default is thumbnail
  const img = $(elm);
  const image_id = img.data('imageid');
  const parent = $(elm).parent();
  let size = parent.width();
  size = size < parent.height() ? parent.height() : size;

  if (elm.src.indexOf(window.ImageControl.localImageServerImagePath) > -1) {
    setLoadLocalImage(false);
    return (elm.src = elm.src.replace(
      window.ImageControl.localImageServerImagePath,
      ''
    ));
  }

  try {
    const newImg = await imageCheckBetterQuality(elm.src, image_id, size);
    elm.src = newImg.src;
  } catch (e) {
    console.log('show error image');
  }
};

function imageCheckBetterQuality(src, imageId, size) {
  return new Promise((resolve, reject) => {
    let newSrc = '';

    if (src.indexOf('/thumbnail/') > -1) {
      // is thumbnail
      newSrc = parseImageId(imageId, size);
    } else if (src.indexOf('/beta/') > -1) {
      newSrc = parseImageId(imageId);
    }

    const img = new Image();
    img.addEventListener('load', () => {
      resolve(img);
    });
    img.addEventListener('error', () => {
      reject();
    });
    img.src = newSrc;
  });
}

function parseImageId(imageId, size) {
  if (isUrl(imageId)) {
    return imageId;
  }

console.log('size v = ' + size);
console.log('id v = ' + imageId);

  if (size) {
if(imageId.indexOf('/') == 0) {
    return `${
      AS.domains.image
    }${imageId}%3Fsize%3D${size}`;
} else {
    return `${
      AS.domains.image
    }${imageId}%3Fsize%3D${size}`;
}
    //return `${
    //  AS.domains.image
    //}/${imageId}%3Fsize%3D${size}`;
  }

if(imageId.indexOf('/') == 0) {
  return `${
    AS.domains.image
  }thumbnail${imageId}`;
} else {
  return `${
    AS.domains.image
  }thumbnail/${imageId}`;
}
}

const isUrl = s => {
  const regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
  return regexp.test(s);
};

// ================================================
// ================================================
// ================================================

/**
 * Check load from local image server or not
 * local image server is at https://localhost:3333
 */
const localImageServer = 'https://localhost:3333';
const localImageServerImagePath = 'https://localhost:3333/img/';

let loadLocalImage = false;

const setLoadLocalImage = (value = false) => {
  loadLocalImage = value;
  if (value) {
    window.ImageDomainURLRead = `${localImageServerImagePath}${
      window.ImageDomainURLRead
    }`;
    AS.domains.image = `${localImageServerImagePath}${AS.domains.image}`;
  } else {
    window.ImageDomainURLRead = window.ImageDomainURLRead.replace(
      localImageServerImagePath,
      ''
    );
    AS.domains.image = AS.domains.image.replace(localImageServerImagePath, '');
  }
};

const initLocalImageServer = async () => {
  const key = 'loadlocalimage';

  const url = new URL(window.location.href);
  let value = url.searchParams.get(key);

  if (!value) {
    value = Cookies.get(key);
  }

  if (value) {
    Cookies.set(key, value, { expires: 10000 });

    if (value === '1') {
      setLoadLocalImage(true);

      $.ajax({
        url: localImageServer
      }).catch(() => {
        console.log('local image server error');
        setLoadLocalImage();
      });
    }
  }
};

initLocalImageServer();

// ================================================
// ================================================
// ================================================

window.checkLoadLocalImage = () => loadLocalImage;

window.ImageControl = {
  imageOnLoad,
  imageOnError,
  imageCheckBetterQuality,
  parseImageId,
  localImageServerImagePath,
  setLoadLocalImage
};
